<template>
    <div>
        <div class="custom-search d-flex justify-content-end">
            <div v-if="$acl.canCreatePermission(role)" class="float-left mr-auto">
                <b-button
                        variant="primary"
                        class="mr-1"
                        @click="newEntity"
                >
                    <span class="text-nowrap">Hozzáadás</span>
                </b-button>
                <b-button
                        id="importExcelButton"
                        variant="success"
                        class="mr-1"
                        v-if="$acl.canCreatePermission(role)"
                        @click="$router.push({name: 'record-catch-import'})"
                >
                    Importálás
                </b-button>
                <b-button
                        id="excelExportButton"
                        :disabled="!rows.length"
                        variant="warning"
                        @click="exportData"
                >
                    Exportálás
                </b-button>
                <b-badge v-for="(filter) in urlFilters" :key="filter.filterKey" class="ml-1" variant="primary">
                    <feather-icon :icon="filter.icon"/>
                    {{ filter.key }}: {{ filter.value }}
                    <b-button variant="link" class="p-0 m-0 text-white" @click="removeUrlFilter(filter.filterKey)">
                        <feather-icon icon="XIcon"/>
                    </b-button>
                </b-badge>
            </div>
            <b-form-group>
                <div class="d-flex align-items-center">
                    <label class="mr-1">Keresés</label>
                    <b-form-input
                            v-model="searchTerm"
                            placeholder="Keresés..."
                            type="text"
                            class="d-inline-block"
                            @input="globalSearch"
                    />
                </div>
            </b-form-group>
            <b-form-group class="ml-2">
                <div class="d-flex align-items-center">
                    <label class="text-nowrap mr-1">Dátum szűrés</label>
                    <flat-pickr
                            v-model="columnFilters.date_range"
                            class="form-control"
                            :config="flatPickRConfig"
                            @input="onColumnFilter"
                    />
                </div>
            </b-form-group>
        </div>
        <b-overlay
                :show="loading"
                spinner-variant="primary"
                spinner-type="grow"
                rounded="sm"
        >
            <!-- table -->
            <vue-good-table
                    mode="remote"
                    :columns="columns"
                    :rows="rows"
                    :rtl="direction" íí
                    :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
                    :sort-options="{
          enabled: true,
          initialSortBy: sortBy
        }"
                    :row-style-class="rowStyleClassFn"
                    @on-row-click="onRowClick"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
            >
                <div slot="emptystate">
                    <div class="vgt-center-align vgt-text-disabled">
                        {{ loading ? 'Adatok betöltése ...' : $t('table.list.empty') }}
                    </div>
                </div>
                <template
                        slot="table-row"
                        slot-scope="props"
                >

                    <!-- Column: Name -->
                    <span
                            v-if="props.column.field === 'fisherman_nationality'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap"
                      v-if="props.row.fisherman_nationality && props.row.fisherman_nationality !== 'UNKNOWN'">{{
                        nationalities.getName(props.row.fisherman_nationality, "hu")
                    }} ({{ props.row.fisherman_nationality }})</span>
                <span class="text-nowrap" v-else>Ismeretlen</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'weight'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ formatFloatToComma(props.row.weight) }} kg</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'released'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.released ? 'Igen' : 'Nem' }}</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'pr'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.pr ? 'Igen' : 'Nem' }}</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'visible'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.visible ? 'Igen' : 'Nem' }}</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'length'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.length ? props.row.length + ' cm' : '-' }}</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'perimeter'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.perimeter ? props.row.perimeter + ' cm' : '-' }}</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'catch_time'"
                            class="text-nowrap"
                    >
                <span class="text-nowrap">{{ props.row.catch_time }}</span>
              </span>

                    <span
                            v-else-if="props.column.field === 'water_name'"
                    >{{ stringHelper.excerpt(props.row.water_name, 35) }} ({{ props.row.water_code }})</span>

                    <span
                            v-else-if="props.column.field === 'report'"
                    >
                <span v-html="$helpers.excerpt(props.row.report)"></span>
              </span>

                    <span
                            v-else-if="props.column.field === 'competition'"
                    >
                <span v-html="$helpers.excerpt(props.row.competition)"></span>
              </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
              <span v-if="props.row.images.length > 0">
                  <b-button
                          v-b-tooltip.hover
                          title="Galéria megtekintése"
                          size="sm"
                          variant="info"
                          v-b-modal.list-record-catch-gallery-modal
                          @click.stop="showGallery(props.row.id)"
                  >
                    <feather-icon
                            icon="ImageIcon"
                    />
                  </b-button>
                </span>
                <span v-if="$acl.canEditPermission(role)">
                  <b-button
                          v-b-tooltip.hover
                          title="Szerkesztés"
                          size="sm"
                          variant="primary"
                          class="ml-1"
                          @click.stop="$router.push({ name: 'modify-record-catch', params: { id: props.row.id }})"
                  >
                    <feather-icon
                            icon="EditIcon"
                    />
                  </b-button>
                </span>
                <span v-if="$acl.canDeletePermission(role)">
                  <b-button
                          v-b-tooltip.hover
                          title="Törlés"
                          size="sm"
                          variant="danger"
                          class="ml-1"
                          @click.stop="deleteEntity(props.row.id, $event)"
                  >
                    <feather-icon
                            icon="XCircleIcon"
                    />
                  </b-button>
                </span>
              </span>

                    <!-- Column: Common -->
                    <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
                </template>

                <!-- pagination -->
                <template
                        slot="pagination-bottom"
                        slot-scope="props"
                >
                    <div class="d-flex justify-content-between flex-wrap">
                        <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ ((page - 1) * pageLength) + 1 }} +
            </span>
                            <b-form-select
                                    v-model="pageLength"
                                    :options="pages"
                                    class="mx-1"
                                    @change="handlePageChange"
                            />
                            <span class="text-nowrap "> a {{ dataFromServer.total }} találatból </span>
                        </div>
                        <div>
                            <b-pagination
                                    :value="1"
                                    :total-rows="dataFromServer.total"
                                    :per-page="dataFromServer.per_page"
                                    first-number
                                    last-number
                                    align="right"
                                    prev-class="prev-item"
                                    next-class="next-item"
                                    class="mt-1 mb-0"
                                    @change="handleChangePage"
                            >
                                <template #prev-text>
                                    <feather-icon
                                            icon="ChevronLeftIcon"
                                            size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                            icon="ChevronRightIcon"
                                            size="18"
                                    />
                                </template>
                            </b-pagination>
                        </div>
                    </div>
                </template>
            </vue-good-table>
        </b-overlay>
        <gallery :entity-id="showGalleryId"></gallery>
        <span v-html="css"></span>
    </div>
</template>

<script>
import {
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BOverlay,
    VBTooltip,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'
import gallery from "@/views/pages/_components/_modal/record-catch/gallery";
import {formatFloatToComma} from "@/libs/formatter/numberFormatter"
import stringHelper from "@/libs/helper/stringHelper";
import moment from "moment/moment";
import FileSaver from 'file-saver'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';
import {Hungarian} from 'flatpickr/dist/l10n/hu.js'

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BButton,
        BOverlay,
        VBTooltip,
        gallery,
        flatPickr,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            css: '',
            role: 'record_catch',
            loading: false,
            pageLength: 10,
            dir: false,
            pages: ['10', '20', '50'],
            columns: [
                {
                    label: this.$t('form.id'),
                    field: 'id',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Az. szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Halfaj',
                    field: 'fish_type_name',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Halfaj szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Horgász',
                    field: 'fisherman_name',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Horgász szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Ország',
                    field: 'fisherman_nationality',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Ország szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Tömeg',
                    field: 'weight',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Tömeg szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Hossz',
                    field: 'length',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Hossz szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Kerület',
                    field: 'perimeter',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Kerület szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Fogás időpontja',
                    field: 'catch_time',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Fogás időpontja szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Vízterület',
                    field: 'water_name',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Vízterület szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Csali',
                    field: 'bait_name',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Csali szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Visszaengedés',
                    field: 'released',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Visszaengedés szerinti szűrés',
                        filterDropdownItems: [
                            {value: true, text: 'Igen'},
                            {value: false, text: 'Nem'}
                        ]
                    },
                    width: '5%',
                },
                {
                    label: 'Beszámoló',
                    field: 'report',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Beszámoló szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'Verseny',
                    field: 'competition',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Verseny szerinti szűrés',
                    },
                    width: '5%',
                },
                {
                    label: 'PR fotó',
                    field: 'pr',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'PR fotó szerinti szűrés',
                        filterDropdownItems: [
                            {value: true, text: 'Igen'},
                            {value: false, text: 'Nem'}
                        ]
                    },
                    width: '5%',
                },
                {
                    label: 'Látható',
                    field: 'visible',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Láthatóság szerinti szűrés',
                        filterDropdownItems: [
                            {value: true, text: 'Igen'},
                            {value: false, text: 'Nem'}
                        ]
                    },
                    width: '5%',
                },
            ],
            showGalleryId: '',
            rows: [],
            page: 1,
            dataFromServer: [],
            filterData: [],
            searchTerm: '',
            sortBy: {
                field: 'id',
                type: 'desc',
            },
            columnFilters: {
                date_range: '',
            },
            urlFilters: [],
            nationalities: '',
            flatPickRConfig: {
                enableTime: true,
                dateFormat: 'Y-m-d H:i',
                locale: Hungarian,
                allowInput: true,
                mode: 'range'
            },
            formatFloatToComma,
            stringHelper,
        }
    },
    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        let storedPageLength = localStorage.getItem('pageLength')
        if (storedPageLength) {
            this.pageLength = storedPageLength
        }

        let storedSearchTerm = localStorage.getItem('recordCatchListSearchTerm')
        if (storedSearchTerm) {
            this.searchTerm = storedSearchTerm
        }

        let storedColumnFilters = localStorage.getItem('recordCatchListColumnFilters')
        if (storedColumnFilters) {
            this.columnFilters = JSON.parse(storedColumnFilters)
            Object.keys(this.columnFilters).forEach(key => {
                const value = this.columnFilters[key]
                const foundIndex = this.columns.findIndex(col => col.field === key)

                if (foundIndex !== -1) {
                    this.$set(this.columns[foundIndex].filterOptions, 'filterValue', value)
                }
            })
        }

        let nationalities = require("i18n-iso-countries")
        nationalities.registerLocale(require("i18n-iso-countries/langs/hu.json"));
        this.nationalities = nationalities

        if (this.$acl.canEditPermission(this.role) || this.$acl.canDeletePermission(this.role)) {
            const actions = [
                {
                    label: this.$t('table.header.actions'),
                    field: 'action',
                    sortable: false,
                    width: '15rem',
                },
            ]

            this.columns = [...actions, ...this.columns]
        }

        this.$store.dispatch('fetchFishTypes', {limit: 100000}).then(response => {
            this.css = '<style>';
            Object.keys(response.data.entities.data).forEach(key => {
                this.css += '.color-' + response.data.entities.data[key].color.replace('#', '') + '{ background-color: ' + response.data.entities.data[key].color + ' }';
                this.css += 'table.vgt-table tr.color-' + response.data.entities.data[key].color.replace('#', '') + ':hover{ background-color: ' + response.data.entities.data[key].color + ' !important }';
            })
        }).finally(() => {
            this.css += '</style>'
        })

        this.checkUrlFilter()
        this.initEntities()
    },
    methods: {
        initEntities() {
            this.loading = true
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }

            this.$store.dispatch('fetchRecordCatches', searchParams).then(response => {
                this.rows = response.data.entities.data
                this.dataFromServer = response.data.entities
                this.page = this.dataFromServer.current_page
                this.pageLength = parseInt(this.dataFromServer.per_page)
            }).finally(() => {
                this.loading = false
            })
        },
        showGallery(id) {
            this.showGalleryId = id
        },
        onRowClick(params) {
            if (this.$acl.canEditPermission(this.role))
                this.$router.push({name: 'modify-record-catch', params: {id: params.row.id}})
        },
        handleChangePage(page) {
            this.page = page
            this.initEntities()
        },
        handlePageChange(active) {
            this.pageLength = active
            localStorage.setItem('pageLength', active)
            this.page = 1
            this.handleChangePage()
        },
        newEntity() {
            this.$router.push({name: 'add-record-catch'})
        },
        deleteEntity(id, event) {
            this.$bvModal
                .msgBoxConfirm('Biztosan törölni szeretnéd?', {
                    title: 'Jóváhagyás',
                    size: 'sm',
                    okVariant: 'primary',
                    okTitle: 'Igen',
                    cancelTitle: 'Nem',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    if (value) {
                        // axios
                        this.$store.dispatch('deleteRecordCatch', id).then(() => {
                            this.initEntities(1)
                            this.$helpers.showSuccessToast(`A rekordot töröltük. (ID: ${id})`)
                        })
                    }
                })
        },
        globalSearch(params) {
            this.page = 1
            this.query = params.searchTerm
            localStorage.setItem('recordCatchListSearchTerm', this.searchTerm)
            this.initEntities()
        },
        onSortChange(params) {
            this.page = 1
            this.sortBy = params[0]
            this.initEntities()
        },
        onColumnFilter(params) {
            this.page = 1
            this.columnFilters = {
                ...this.columnFilters,
                ...params.columnFilters
            };
            localStorage.setItem('recordCatchListColumnFilters', JSON.stringify(this.columnFilters))
            this.initEntities()
        },
        checkUrlFilter() {
            const storedColumnFilters = JSON.parse(localStorage.getItem('recordCatchListColumnFilters') || '{}')

            this.page = 1
            if (typeof this.$route.query.fisherman_id !== "undefined" || typeof storedColumnFilters.fisherman_id !== "undefined") {

                const fishermanId = storedColumnFilters.fisherman_id || this.$route.query.fisherman_id

                this.$store.dispatch('fetchFisherman', fishermanId).then(response => {
                    this.urlFilters.push({
                        filterKey: 'fisherman_id',
                        key: 'Horgász',
                        value: response.data.entity.name,
                        icon: 'UserIcon',
                    })
                })

                this.columnFilters = {
                    fisherman_id: fishermanId
                }
            }
            if (typeof this.$route.query.fish_category_id !== "undefined" || typeof storedColumnFilters.fish_category_id !== "undefined") {

                const fishCategoryId = storedColumnFilters.fish_category_id || this.$route.query.fish_category_id

                this.$store.dispatch('fetchFishCategory', fishCategoryId).then(response => {
                    this.urlFilters.push({
                        filterKey: 'fish_category_id',
                        key: 'Halkategória',
                        value: response.data.entity.name,
                        icon: 'FolderIcon',
                    })
                })

                this.columnFilters = {
                    fish_category_id: fishCategoryId
                }
            }
            if (typeof this.$route.query.fish_type_id !== "undefined" || typeof storedColumnFilters.fish_type_id !== "undefined") {

                const fishTypeId = storedColumnFilters.fish_type_id || this.$route.query.fish_type_id

                this.$store.dispatch('fetchFishType', fishTypeId).then(response => {
                    this.urlFilters.push({
                        filterKey: 'fish_type_id',
                        key: 'Halfaj',
                        value: response.data.entity.name,
                        icon: 'ListIcon',
                    })
                })

                this.columnFilters = {
                    fish_type_id: fishTypeId
                }
            }
            if (typeof this.$route.query.water_id !== "undefined" || typeof storedColumnFilters.water_id !== "undefined") {

                const waterId = storedColumnFilters.water_id || this.$route.query.water_id

                this.$store.dispatch('fetchWater', waterId).then(response => {
                    this.urlFilters.push({
                        filterKey: 'water_id',
                        key: 'Vízterület',
                        value: response.data.entity.name,
                        icon: 'DropletIcon',
                    })
                })

                this.columnFilters = {
                    water_id: waterId
                }
            }
            if (typeof this.$route.query.bait_id !== "undefined" || typeof storedColumnFilters.bait_id !== "undefined") {

                const baitId = storedColumnFilters.bait_id || this.$route.query.bait_id

                this.$store.dispatch('fetchBait', baitId).then(response => {
                    this.urlFilters.push({
                        filterKey: 'bait_id',
                        key: 'Csali',
                        value: response.data.entity.name,
                        icon: 'FeatherIcon',
                    })
                })

                this.columnFilters = {
                    bait_id: baitId
                }
            }
            if (typeof this.$route.query.visible !== "undefined" || typeof storedColumnFilters.visible !== "undefined") {

                const visible = storedColumnFilters.visible || this.$route.query.visible

                this.urlFilters.push({
                    filterKey: 'visible',
                    key: 'Látható',
                    value: 'Igen',
                    icon: 'EyeIcon',
                })

                this.columnFilters = {
                    visible: visible
                }
            }
            if (typeof this.$route.query.onlyTodo !== "undefined" || typeof storedColumnFilters.onlyTodo !== "undefined") {
                this.urlFilters.push({
                    filterKey: 'onlyTodo',
                    key: 'Csak teendők',
                    value: 'Igen',
                    icon: 'CheckIcon',
                })

                this.columnFilters = {
                    visible: "false"
                }
            }
            if (typeof this.$route.query.user_id !== "undefined" || typeof storedColumnFilters.user_id !== "undefined") {

                const userId = storedColumnFilters.user_id || this.$route.query.user_id

                this.$store.dispatch('fetchUser', userId).then(response => {
                    this.urlFilters.push({
                        filterKey: 'user_id',
                        key: 'Felhasználó',
                        value: response.data.entity.name,
                        icon: 'UsersIcon',
                    })
                })

                this.columnFilters = {
                    user_id: userId
                }
            }
            this.initEntities()
        },
        removeUrlFilter(filterKey) {
            this.urlFilters = this.urlFilters.filter(filter => filter.filterKey !== filterKey);

            const query = {...this.$route.query};
            delete query[filterKey];

            this.$router.push({query});

            delete this.columnFilters[filterKey];

            if (filterKey === 'onlyTodo') {
                delete this.columnFilters['visible'];
            }
            localStorage.setItem('recordCatchListColumnFilters', JSON.stringify(this.columnFilters))

            this.initEntities();
        },
        rowStyleClassFn(row) {
            return 'color-' + row.fish_type_color.replace('#', '')
        },
        exportData() {
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }
            this.loading = true
            this.$store.dispatch('exportRecordCatchList', searchParams).then(response => {
                let filename = 'rekordok-' + moment().format('YYYY-MM-DD-HH-mm') + '.xlsx'
                FileSaver.saveAs(response.data, filename)
            }).finally(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
@media (max-width: 576px) {
    .custom-search {
      flex-direction: column;
    }

    .custom-search div {
      display: flex;
      flex-direction: column;
      margin: 0 !important;
      float: none !important;
    }

    .custom-search div button, .custom-serach div input {
      width: 100%;
      margin-bottom: 15px;
    }

    .form-group {
      margin-left: 0px !important;
    }
}
</style>
